<template>
  <div> <br />
    <h2 class="mt-2 ml-2 hedderLogin" id="getting-started">
      <a href="#getting-started" class="header-anchor">Forgot</a> Password
    </h2>
    <br />
    <form class="container mt-1 ml-2" style="width: 100%">
      <p>
        <label class="fontSizeData">Username</label>
        <input class="inputForm" v-model="usernameforgot" type="text" />
      </p>
      <p>
        <label class="fontSizeData">E-mail</label>
        <input class="inputForm" v-model="emailforgot" type="text" />
      </p>
    </form>
    <br />
    <vs-row>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button
          @click="sendpassword"
          color="warning"
          class="container-fluid"
          v
          type="filled"
          style="width: 65%; border-radius: 20px"
          ><h5>Reset Password</h5>
        </vs-button></vs-col
      >
    </vs-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    checkbox: false,
    usernameforgot: "",
    emailforgot: "",
  }),
  methods: {
    sendpassword() {
      var body = {
        column: "*",
        email: this.emailforgot,
        username: this.usernameforgot,
      };
      this.$API.post("forgotpassword",body,{ 
      headers: {
      'Access-Control-Request-Method': '*',
      'Access-Control-Request-Headers': '*',
      'Access-Control-Allow-Origin': '*'
      },
      username: "admin",
      password: "admin",
      role: this.checkbox}).then((result) => {
        if(result){
          //Tag Email Sent
          this.$vs.notify({title:'Email was sent',text:'Please check your email address' ,time:4000,color:'primary',position:'top-center'})
          // console.log("Email sent")
            this.$router.push('/Resetpassword') 
        }
      }).catch(error => {
        if(error){
          //Tag Invalid Email
          this.$vs.notify({title:'Invalid',text:'Please try again' ,time:4000,color:'warning',position:'top-center'})
          // console.log(err.response.status)
          // console.log("Invalid Email")
        }
      })
     

      this.usernameforgot
      this.emailforgot



      this.usernameforgot;
      this.emailforgot;
    },
  },
};
</script>

<style>
</style>